import { createFileRoute } from "@tanstack/react-router";
import { Clock } from "lucide-react";

import { DravianLogo } from "@/components/dravian/logo";
import { FooterStrip } from "@/components/dravian/footer-strip";

export const Route = createFileRoute("/onboarding-pending")({
  head: () => ({
    meta: [
      { title: "Waiting for setup — Dravian Horizon" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: OnboardingPendingPage,
});

function OnboardingPendingPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="flex items-center justify-between px-6 py-5 border-b border-border">
        <DravianLogo />
      </header>
      <main className="flex-1 grid place-items-center px-6">
        <div className="text-center max-w-[480px]">
          <div className="mx-auto h-14 w-14 rounded-full border border-amber-400/40 bg-amber-500/10 grid place-items-center mb-6">
            <Clock className="h-6 w-6 text-amber-400" />
          </div>
          <h1 className="text-[22px] font-semibold tracking-tight">
            Your organization is still being set up.
          </h1>
          <p className="text-[13px] text-muted-foreground mt-3 leading-relaxed">
            An organization owner or admin needs to finish the initial setup of
            this Horizon deployment before workspaces are available. Once
            they're done, refresh this page and you'll be able to sign in
            normally.
          </p>
          <p className="text-[11px] text-muted-foreground mt-4">
            If you believe you should be able to set this up, ask your operator
            to grant you the <strong>admin</strong> or <strong>supervisor</strong> role.
          </p>
        </div>
      </main>
      <FooterStrip />
    </div>
  );
}
